import _styled from"@emotion/styled";import*as React from"react";import{AntdSelect,Button,Divider}from"@wp/src/components/common";import{Icon}from"@wp/src/components/common";export const PortfoliosListingSelect=_styled(AntdSelect)`
  ${{"width":"100%","paddingLeft":"0.25rem","paddingRight":"0.25rem","fontSize":"1rem","lineHeight":"32px","fontWeight":"400","--tw-text-opacity":"1","color":"rgb(86 85 89 / var(--tw-text-opacity))"}}

  &.ant-select:not(.ant-select-customize-input) .ant-select-selector,
  &.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer):hover .ant-select-selector {
    ${{"borderRadius":"0.5rem","paddingLeft":"0.75rem","paddingRight":"0.75rem","paddingTop":"0.5rem","paddingBottom":"0.5rem"}}
    &,
    &:hover,
    &:active {
      ${props=>props.isBordered?{"borderWidth":"var(--nextui-border-width-medium)","--tw-shadow":"0 0 #0000","--tw-shadow-colored":"0 0 #0000","boxShadow":"var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"}:{"borderStyle":"none","--tw-shadow":"0 0 #0000","--tw-shadow-colored":"0 0 #0000","boxShadow":"var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"}}
    }
    ${props=>props.isDraftPortfolioSelected?{"height":"48px","--tw-border-opacity":"1","borderColor":"rgb(221 214 254 / var(--tw-border-opacity))","--tw-bg-opacity":"1","backgroundColor":"rgb(237 233 254 / var(--tw-bg-opacity))"}:{"height":"40px","--tw-border-opacity":"1","borderColor":"rgb(209 213 219 / var(--tw-border-opacity))","--tw-bg-opacity":"1","backgroundColor":"rgb(229 231 235 / var(--tw-bg-opacity))"}}

  .ant-select-selection-item {
    ${{"display":"flex","alignItems":"center","--tw-text-opacity":"1","color":"rgb(86 85 89 / var(--tw-text-opacity))"}} !important;
  }

  .ant-select-arrow {
    > svg {
      ${{"height":"20px","width":"20px","--tw-text-opacity":"1","color":"rgb(115 115 115 / var(--tw-text-opacity))"}}
    }
    ${{"right":"12px"}}
    polyline {
      ${{"strokeWidth":"4"}}
    }
  }

  .ant-select-single.ant-select-open.ant-select-selection-item {
    ${{"--tw-text-opacity":"1","color":"rgb(86 85 89 / var(--tw-text-opacity))"}}
  }
`;export const OptionLabel=_styled.div`
  ${{"overflow":"hidden","textOverflow":"ellipsis","whiteSpace":"pre","fontSize":"1rem","lineHeight":"1.5rem","fontWeight":"600"}}

  & > div {
    ${{"fontSize":"0.75rem","lineHeight":"1rem","fontWeight":"600","--tw-text-opacity":"1","color":"rgb(139 92 246 / var(--tw-text-opacity))"}}
  }
`;export const StyledPortfolioOptionsDropdownContainer=_styled.div`
  ${{"--tw-bg-opacity":"1","backgroundColor":"rgb(255 255 255 / var(--tw-bg-opacity))"}}

  .ant-select-item {
    ${{"minHeight":"0px"}}
  }

  .ant-select-item.ant-select-item-group {
    ${{"paddingLeft":"1rem","paddingRight":"1rem"}}
  }

  .ant-select-item.ant-select-item-option {
    & > .ant-select-item-option-content {
      ${{"fontSize":"1rem","lineHeight":"1.5rem","fontWeight":"400"}}
    }

    ${{"paddingLeft":"1rem","paddingRight":"1rem","paddingTop":"0.5rem","paddingBottom":"0.5rem","--tw-text-opacity":"1","color":"rgb(86 85 89 / var(--tw-text-opacity))"}}
  }
`;export const PortfolioSelectedOptionTick=()=>React.createElement(Icon,{icon:"lucide:check",css:{"--tw-text-opacity":"1","color":"rgb(18 161 80 / var(--tw-text-opacity))"},width:"16",height:"16"});export const PortfolioOptionsGroupDivider=_styled(Divider)`
  ${{"marginTop":"0.5rem","marginBottom":"0.5rem","--tw-bg-opacity":"1","backgroundColor":"rgb(242 242 244 / var(--tw-bg-opacity))","padding":"0px"}}
`;export const OptGroupButton=_styled(Button)`
  ${{"paddingTop":"0.5rem","paddingBottom":"0.5rem"}}

  &,
  & > span {
    ${{"fontSize":"0.875rem","lineHeight":"1.25rem","fontWeight":"600","--tw-text-opacity":"1","color":"rgb(163 163 163 / var(--tw-text-opacity))"}}
  }
`;export const ManagePortfoliosContainer=_styled.div`
  ${{"padding":"0.5rem"}}
`;